// tslint:disable-next-line:no-any
export const getIntoObject = (obj: LooseObject, path: Array<string | number>, empty: any = undefined): any => {
  if (obj) {
    if (path[0] !== undefined) {
      return getIntoObject(obj[path.splice(0, 1)[0]], path, empty);
    }
    return obj;
  }
  return empty;
};



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/helpers/index.ts